import { MegaMenuStandard } from "../../../../modules/mega-menu/components/MegaMenuStandard/MegaMenuStandard";
import type { IMegaMenuBlockProps } from "./MegaMenuBlock.props";

export const MegaMenuBlock = (props: IMegaMenuBlockProps) => {
  if (!props.logo && !props.items?.length && !props.actions?.length) {
    return null;
  }

  return <MegaMenuStandard {...props} />;
};

MegaMenuBlock.displayName = "Block::MegaMenuBlock";
